import React, { useState } from "react";
import { Alert, Button, ButtonGroup, Divider, FormGroup, FormLabel, Stack, TextField } from "@mui/material";
import User from "../../types/User";
import CrisisAlertIcon from '@mui/icons-material/CrisisAlert';
import ReviewsIcon from '@mui/icons-material/Reviews';
import { LoadingButton } from "@mui/lab";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Solution, SolutionState } from "../../types/Solutions";
import { ChangeProps } from "../Lessons/Show";
import Toolbox from "../Shared/Toolbox";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from "dayjs";

export type ActionProps = {
  solution: Solution;
  user: User;
  isUpdating: boolean;
}

const Actions = (props: ActionProps & ChangeProps) => {

  const OwnerActions = () => {
    const [defineTarget, shouldDefineTarget] = useState<boolean>(false);
    const [type, setType] = useState<"quantitative" | "qualitative">("quantitative");
    const [date, setDate] = useState<number>();

    const save = () => {
      props.onSave({
        target_at: date!,
        measures: {
          type: type
        }
      })
    }

    return <>
      <LoadingButton loading={props.isUpdating} variant="outlined" color="primary" size="small" disabled={typeof (props.solution?.owner) === "undefined"} onClick={() => shouldDefineTarget(true)} startIcon={<CrisisAlertIcon />}>Define target</LoadingButton>

      {defineTarget && <Toolbox title="Define target" maxWidth="sm" onClose={() => shouldDefineTarget(false)}>
        <FormGroup>
          {/* <FormLabel>Choose whether you will measure effectiveness quantitatively or qualitatively:</FormLabel>

          <ButtonGroup size="small" sx={{ justifyContent: "center", my: 2 }}>
            <Button color="info" variant="contained">Quantitative</Button>
            <Button color="secondary" variant="outlined" disabled>Qualitative</Button>
          </ButtonGroup> */}
        
          <Alert severity="info">
            The selected lessons learned will save you<br />
            <strong>{`${Math.round(props.solution.lessons.reduce(function (a, b) {
              return a + b.annual_time_lost;
            }, 0) / 60)}`} lost hours per year</strong><br />
            once the solutions is approved.
          </Alert>

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker value={date ? dayjs.unix(date) : undefined} onChange={date => setDate(dayjs(date).unix())} minDate={dayjs()} label="Target date" sx={{ mt: 2 }} />
          </LocalizationProvider>
        </FormGroup>

        <Divider />

        <FormGroup>
          <Button variant="outlined" color="primary" size="small" onClick={save}>Save</Button>
        </FormGroup>
      </Toolbox>}
    </>
  }

  const ApproverActions = () => {
    const [publish, shouldPublish] = useState<boolean>(false);
    const [mitigation, setMitigation] = useState<string>();

    return <>
      <LoadingButton loading={props.isUpdating} variant="outlined" color="success" size="small" onClick={() => shouldPublish(true)} startIcon={<ReviewsIcon />}>Publish solution</LoadingButton>

      { publish && <Toolbox title="Publish solution" maxWidth="sm" onClose={() => shouldPublish(false)}>
        <TextField variant="filled" multiline rows={3} placeholder="Mitigation" value={mitigation} onChange={e => setMitigation(e.currentTarget.value)} />
        <Button variant="outlined" color="success" disabled={!mitigation} onClick={() => props.onSave({mitigation: mitigation!})}>Publish</Button>
      </Toolbox> }
    </>
  }

  const renderContent = () => {
    switch (SolutionState[props.solution.state]) {
      case SolutionState.resolved:
        break;
      case SolutionState.defined:
        if (props.solution?.owner?.id === props.user.id) {
          return <><Divider sx={{mb: 2}} /><ApproverActions /></>;
        } break;
      default:
        return <><Divider sx={{mb: 2}} /><OwnerActions /></>;
    }
  }

  return <Stack direction="row" spacing={1} justifyContent="center">{renderContent()}</Stack>
}

export default Actions;